import { IPlayersGroupGames } from "@grassrootly/api";
import { PayloadAction, createPersistReducer, initReducer, PersistConfig } from "@grassrootly/rn-core";
import AsyncStorage from "@react-native-async-storage/async-storage";

export interface PreviousGames {
  previous_games: { [key: string]: IPlayersGroupGames };
}

const initialState: PreviousGames = {
  previous_games: {},
};

const playersPreviousGamesSlice = initReducer({
  name: "previous-games",
  initialState,
  reducers: {
    setPlayersPreviousGames: (state: PreviousGames, action: PayloadAction<IPlayersGroupGames[]>) => {
      action.payload.forEach((game) => {
        state.previous_games[game.playerId] = game;
      });
    },
    cleanState: () => {
      return initialState;
    },
  },
});

const persistConfig: PersistConfig<PreviousGames> = {
  key: "previous-games",
  storage: AsyncStorage,
};

export const playersPreviousGamesActions = playersPreviousGamesSlice.actions;

export default createPersistReducer(persistConfig, playersPreviousGamesSlice.reducer);
